import React from "react";
import DOMPurify from "dompurify";
import styles from "./terminos-condiciones.module.css";

const TerminosCondiciones = ({ terminosCondiciones, aclaraciones, fondos, esAP, fixedText }) => {
    const renderTerminos = (lista, className) => {
        return (
            <React.Fragment>
                {lista !== undefined
                    ? lista.map((item, index) => {
                        return (
                            (esAP ?
                                <div className={`${styles.descripcion} ${className !== undefined ? className : null}`} key={'item_' + index} style={{ marginLeft: '-10px' }}>
                                    {item.descripcion}
                                </div>
                                :
                                <li className={`${styles.descripcion} ${className !== undefined ? className : null}`} key={'item_' + index}>
                                    <div dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(item.descripcion) }} />
                                </li>
                            )
                        )
                    })
                    : null
                }
            </React.Fragment>
        )
    }

    return (
        <React.Fragment>
            {fondos !== undefined
                ? <div className={styles.body}>
                    <div className={styles.div_fondos_titulo}>
                        Categorías de los Fondos de Inversión
                    </div>
                    <div>
                        <ul className={styles.ul_fondos}>
                            {renderTerminos(fondos, styles.li_fondos)}
                        </ul>
                    </div>
                </div>
                : null
            }

            {(terminosCondiciones !== undefined && terminosCondiciones.length > 0) || (aclaraciones !== undefined && aclaraciones.length > 0)
                ? <div className={styles.body}>
                    {/* TERMINOS Y CONDICIONES */}
                    {terminosCondiciones !== undefined
                        ? <div>
                            <ol>{renderTerminos(terminosCondiciones)}</ol>
                        </div>
                        : null
                    }

                    {/* ACLARACIONES */}
                    {aclaraciones !== undefined
                        ? <div>
                            <ol className={styles.ol_aclaraciones}>
                                {renderTerminos(aclaraciones)}
                            </ol>
                        </div>
                        : null
                    }
                    {
                        fixedText &&
                        <div className={styles.fixedText}>{fixedText}</div>
                    }
                </div>
                : null
            }

        </React.Fragment>
    )
}

export default TerminosCondiciones;